import Select from 'react-select';
import { useState, useEffect } from 'react';
import { BaseSelector } from '../../../../domain/shared';
import { ProjectsRepository } from '../../../../infrastructure/repositories/projects/projectRepository';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    name: string;
    isDisabled?: boolean;
}

export default function ProjectStatusSelector({
    onChange,
    value,
    name,
    isDisabled = false,
}: Props) {
    const [status, setStatus] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        ProjectsRepository.GetProjectStatusList().then((res) => {
            setIsLoading(false);
            setStatus(
                res.map((dt) => ({
                    label: dt.name,
                    value: dt.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Estados del proyecto
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                isDisabled={isDisabled}
                name='color'
                options={status}
                onChange={(c) => {
                    onChange(name, c?.value);
                }}
                value={
                    status.find((c) => c.value === value) ?? {
                        label: 'Seleccione',
                        value: 0,
                    }
                }
            />
        </div>
    );
}
